<!--
 * @Author: Jone
 * @Date: 2022-02-16 11:37:04
 * @LastEditors: Jone
 * @LastEditTime: 2022-07-04 15:56:04
 * @FilePath: frontend\lib\components\MdEditModule.vue
 * @Description: 自定义模板新增、修改页面
 *
 * Copyright (c) 2022 by 青岛百洋智能科技股份有限公司, All Rights Reserved.
-->
<template>
  <div
    class="oecp-md-element-form height100 flex flex-direction-column"
    v-loading="htmlLoading"
  >
    <el-row
      v-if="showHeader||showGoBack"
      class="oecp-component-header"
    >
      <el-col :span="12">
        <template v-if="showGoBack">
          <el-page-header
            @back="goBack"
            title=''
          >
            <div slot="content">
              <template v-if="!!$slots.title">
                <slot name="title"></slot>
              </template>
              <div
                v-else-if="!!title"
                class="title-style"
              >修改自定义模板</div>
              <div v-else>&nbsp;</div>
            </div>
          </el-page-header>
        </template>
        <template v-else>
          <template v-if="!!$slots.title">
            <slot name="title"></slot>
          </template>
          <div
            v-else-if="!!title"
            class="title-style"
          >修改自定义模板</div>
          <div v-else>&nbsp;</div>
        </template>
      </el-col>
      <el-col
        v-show="editable&&showSaveBtn"
        :span="12"
      >
        <el-row
          type="flex"
          justify="end"
        >
          <el-button
            v-oecp-auth:[{type}]="'elementForm.save'"
            :loading="loading"
            :icon="stateId?'el-icon-edit':'el-icon-plus'"
            @click="handleSave"
            type="primary"
            size="small"
            class="addBtn"
          >{{submitBtnText}}</el-button>
        </el-row>
      </el-col>
      <el-divider
        v-if="showHeader||showGoBack"
        class="oecp-divider"
      />
    </el-row>
    <el-row style="width: 100%;flex:1;overflow:auto;">
      <el-col
        :span="13"
        class="flex flex-direction-column height100"
      >
        <el-tabs
          v-model="activeName"
          type="card"
          style="height:46px"
        >
          <el-tab-pane
            label="数据元"
            name="source"
            size="mini"
          ></el-tab-pane>
          <el-tab-pane
            label="数据集"
            name="collection"
          ></el-tab-pane>
        </el-tabs>
        <div
          class="typesBox flex"
          style="align-items: center;"
          v-if="!searchVisible"
        >
          <ul
            class="typesBox flex flex-start"
            style="width:auto"
          >
            <li
              v-for="(item,index) in tabListArr"
              :key="index"
              :class="activeIndex == item.id ?'activeLi':''"
              @click="activeIndex = item.id"
            ><i :class="item.icon"></i>{{item.name}}</li>
          </ul>
          <el-input
            class="headerSearch"
            v-if="activeName == 'source'"
            ref="searchInputRef"
            placeholder="请搜索数据元的名称"
            v-model="searchValue"
            @keyup.enter.native="searchVal"
          >
            <i
              slot="suffix"
              class="el-icon-search"
              @click="searchVal"
            ></i>
          </el-input>
        </div>
        <div
          class="typesBox flex flex-between"
          style="align-items: center;"
          v-else
        >
          <el-input
            ref="searchInputRef"
            v-model="searchValue"
            @keyup.enter.native="searchVal"
          >
            <i
              slot="prefix"
              class="el-icon-search"
              @click="searchVal"
            ></i>
            <i
              slot="suffix"
              class="el-icon-close"
              @click="closeSearch"
            ></i>
          </el-input>
        </div>
        <div
          :style="sliderStyle"
          class="boxInner"
          v-if="activeName == 'collection'"
        >
          <div
            v-for="(item,index) in tagList"
            :key="index"
          >
            <p
              v-if="item.children"
              class="flex flex-center"
              style="justify-content: flex-start;"
            >
              <img
                src="../common/img/tagImg.png"
                style="height: 12px;width: 12px;margin-right: 6px"
              />
              {{item.name}}
              <span
                @click="chooseTag(item.children[0],index,index)"
                style="margin-left: 6px;"
                :class="item.children[0].choosed == 1?'allChoose':'notAllChoose'"
              >
              </span>
            </p>
            <span
              v-for="(items,indexd) in item.children"
              v-show="items.id !== 'allIn'"
              @click="chooseTag(items,indexd,index)"
              :class="items.choosed == 1?'chooseItem':''"
              style="border:1px solid #90AFFF;background:#EDF2FF;border-radius: 4px;font-size: 12px;margin: 4px;padding: 0px 7px;display: inline-block;cursor: pointer;color: #497EE1;line-height:24px;height:24px;"
              :key="indexd"
            >{{items.name}}</span>
          </div>
        </div>
        <div
          v-if="activeName == 'collection'"
          style="width: 100%;text-align: center;padding: 4px 0;color:#409eff;font-size: 12px;cursor:pointer;background:#fff;"
          @click="changeTagHeight"
        >
          {{sliderStyle.height == 'auto'?'收起':'展开'}}
        </div>
        <el-row
          class="templateLeft height100"
          v-if="!searchVisible"
        >
          <el-col
            :span="
          12"
            style="height: 100%;overflow: auto;"
          >
            <!-- 数据元和数据集不一样 数据元是树状结构，数据集是按照分类查询，然后搜索到数据集 -->
            <el-input
              placeholder="输入关键字进行过滤"
              v-model="filterText"
              style="width:96%"
            >
              <i
                slot="suffix"
                class="el-icon-search"
              ></i>
            </el-input>
            <el-tree
              v-loading="treeLoading"
              :highlight-current="true"
              :data="data"
              :props="defaultProps"
              ref="tree"
              node-key="id"
              :filter-node-method="filterNode"
            >
              <span
                class="custom-tree-node"
                slot-scope="{ node, data }"
              >
                <!-- <span>{{node.name}}</span> -->
                <span style="width: 100%;">
                  <el-button
                    style="color:#666;width: 100%;"
                    type="text"
                    size="mini"
                    :title="node.label"
                    @click="() => append(data)"
                  >
                    {{node.label}}
                  </el-button>
                </span>
              </span>
            </el-tree>

          </el-col>
          <el-col
            :span="12"
            style="padding-left:10px;height: 100%;overflow: auto;"
            class="tagBox flex"
          >
            <div class="tagTop flex flex-center">
              <div
                v-if="!chooseFlag && batchList.length > 0"
                style="width:100%;align-items: center;height: 100%;"
              >
                <el-button
                  type="text"
                  size="small"
                  @click="chooseFlag=true"
                  style="font-size: 16px"
                >
                  <span class="flex flex-center">
                    <i class="el-icon-more iconChoose"></i>
                    <span>批量选择</span>
                  </span>
                </el-button>
              </div>
              <div
                class="flex flex-between"
                style="width:100%;align-items: center;height: 100%;"
                v-if="chooseFlag && batchList.length > 0"
              >
                <el-checkbox
                  :indeterminate="isIndeterminate"
                  v-model="checkAll"
                  @change="handleCheckAllChange"
                >全选选择</el-checkbox>
                <p style="font-size:14px">共<span style="padding: 0 2px;font-weight:600">{{checkList.length}}</span>项</p>
              </div>
              <div
                v-if="batchList.length == 0"
                class="flex flex-center"
                style="flex-direction:column;padding-top: 20px;"
              >
                <img
                  style="width:60%"
                  src="data:image/png;base64,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"
                />
                <p style="color:#999;font-size:12px;padding-top:10px"></p>
              </div>
            </div>
            <div
              v-if="!chooseFlag"
              class="tagListBox"
            >
              <p
                v-for="(item,ind) in batchList"
                :key="ind"
                @click="pushBatch(item)"
              >
                <span :title="item.name">{{item.name}}</span>
              </p>
            </div>
            <div
              v-else
              class="tagListBox"
            >
              <el-checkbox-group
                @change="handleCheckedCitiesChange"
                v-model="checkList"
              >
                <el-checkbox
                  v-for="(item,ind) in batchList"
                  :key="ind"
                  :label="item.name"
                ></el-checkbox>
              </el-checkbox-group>
            </div>
            <div
              v-if="chooseFlag"
              class="flex flex-center"
              style="width:100%;padding-top: 6px"
            >
              <el-button
                size="mini"
                @click="chooseFlag = false"
              >取消</el-button>
              <el-button
                size="mini"
                type="primary"
                @click="confirmBtn"
              >确定</el-button>
            </div>
          </el-col>
        </el-row>
        <div
          class="templateLeft height100 templateLeftElse"
          v-else
        >
          <div
            class="tagListBox"
            v-if="batchList && batchList.length >0"
          >
            <p
              v-for="(item,ind) in batchList"
              :key="ind"
              @click="pushBatch(item)"
            >
              <span
                v-if="item.corpCode!==null"
                :title="item.name+'--'+item.corpName"
                style="background: #c0c4cc;"
              >{{item.name}}--{{item.corpName}}</span>
              <span
                v-else
                :title="item.name"
              >{{item.name}}</span>
            </p>
          </div>
          <div
            class="tagListBox"
            v-else
          >
            <div style="display: flex;justify-content: center;align-items: center;padding-top: 100px;">
              <img
                style="width:40%"
                src="data:image/png;base64,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"
              />
            </div>
            <div style="display: flex;justify-content: center;align-items: center;">
              <p style="color:#666;font-size:14px;padding-top:20px">没有搜索相关结果，请重试或修改检索表达式</p>
            </div>

          </div>
        </div>
      </el-col>
      <el-col
        :span="11"
        class="height100 flex flex-direction-column"
        style="overflow:hidden;"
      >
        <div style="height: 46px"></div>
        <!-- <span style="font-size:10px;padding-top:10px;color: rgba(0, 0, 0, 0.45);">
          <i
            class="el-icon-warning-outline"
            style="padding-right:4px;color:red"
          ></i>该模板由浪潮集团提供，您可以在该模板的基础上进行模板定制。
        </span> -->
        <div class="editTemplateRight height100 flex flex-direction-column">
          <p
            class="titleRight"
            v-if="!titleInput"
          >{{selfData.name}}<el-button type="text"><i
                class="el-icon-edit"
                @click="showInput"
              ></i></el-button>
          </p>
          <el-input
            v-model="selfData.name"
            class="inputTitle"
            maxlength="20"
            v-else
            placeholder="请输入标题"
            ref="ipt"
            @blur="hideInput"
            @keyup.enter.native="hideInput"
          ></el-input>
          <div
            class='titleRightListBox'
            style="flex:1"
            v-if="(contentData.self && contentData.self.length !==0) || (contentData.clips && contentData.clips.length !==0)"
          >
            <div>

              <div v-if="contentData.self && contentData.self.length !==0">
                <el-collapse @change="handleChange">
                  <el-collapse-item
                    v-for="(item,index) in contentData.self"
                    :key="index"
                    :title="item.name"
                    :name="index"
                    @mouseover.native="collapseOver(index)"
                    @mouseleave.native="collapseLeave(index)"
                  >
                    <template slot="title">
                      <div
                        class="flex"
                        style="width:100%;flex-wrap: nowrap;"
                        @click="itemDetails(item)"
                      >
                        <p
                          style="height:100%;min-width: 0;padding-right: 10px;"
                          class="itemTitle wordSingle"
                        >
                          {{item.name}}
                        </p>
                        <p
                          class="btnBox"
                          v-if="hoverIndex === index"
                        >
                          <el-button
                            type="text"
                            size="mini"
                            icon="el-icon-top"
                            @click.stop="moveUp(contentData.self,index)"
                          >上移</el-button>
                          <el-button
                            type="text"
                            size="mini"
                            icon="el-icon-bottom"
                            @click.stop="moveDown(contentData.self,index)"
                          >下移</el-button>
                          <el-button
                            @click.stop="deleteArr(contentData.self,index)"
                            type="text"
                            size="medium"
                            style="padding: 0"
                            title="删除"
                            circle
                          >
                            <i
                              style="color: #FF432E;background: #FFEEEB;border-radius: 100%;font-size:13px;padding:2px;font-weight:600;"
                              class="el-icon-close"
                            ></i>
                          </el-button>
                        </p>
                      </div>
                    </template>
                    <div class="infoBox">
                      <p class="flex">
                        <span class="wordSingle">HiTA标识符</span>
                        <span class="wordSingle">{{item.code || '暂无'}}</span>
                      </p>
                      <p class="flex">
                        <span class="wordSingle">别名</span>
                        <el-input
                          v-model="item.elementAlias"
                          placeholder="请输入别名"
                          size="mini"
                        ></el-input>
                      </p>
                      <p class="flex">
                        <span class="wordSingle">定义</span>
                        <el-input
                          v-model="item.elementDefination"
                          placeholder="请输入定义"
                          size="mini"
                        ></el-input>
                      </p>
                      <p class="flex">
                        <span class="wordSingle">来源标识符</span>
                        <span class="wordSingle">{{item.sourceCode || '暂无'}}</span>
                      </p>
                      <!-- <p class="flex">
                      <span class="wordSingle">定义</span>
                      <span
                        class="wordSingle"
                        :title="item.ext.definition"
                        v-if="item.ext"
                      >{{item.ext.definition || '暂无'}}</span>
                      <span
                        class="wordSingle"
                        v-else
                      >暂无</span>

                    </p> -->
                      <p class="flex">
                        <span class="wordSingle">数据类型</span>
                        <span
                          class="wordSingle"
                          v-if="item.ext"
                        >{{item.ext.data_type || '暂无'}}</span>
                        <span
                          class="wordSingle"
                          v-else
                        >暂无</span>
                      </p>
                      <p class="flex">
                        <span class="wordSingle">表示格式</span>
                        <span
                          class="wordSingle"
                          v-if="item.ext"
                        >{{item.ext.display_format || '暂无'}}</span>
                        <span
                          class="wordSingle"
                          v-else
                        >暂无</span>
                      </p>
                      <!-- <p class="flex">
                      <span class="wordSingle">允许值类型</span>
                      <span class="wordSingle">不可枚举型</span>
                    </p> -->
                      <p class="flex">
                        <span class="wordSingle">允许值</span>
                        <span
                          class="wordSingle"
                          v-if="item.ext"
                        >{{item.ext.range || '暂无'}}</span>
                        <span
                          class="wordSingle"
                          v-else
                        >暂无</span>
                      </p>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>

              <div v-if="contentData.clips && contentData.clips.length !==0">
                <div
                  v-for="(item,index) in contentData.clips"
                  :key="index"
                  @mouseover="collapseTagOver(index)"
                  @mouseleave="collapseTagLeave(index)"
                >
                  <div
                    style="padding: 14px 22px 8px 4px;border-bottom: 1px solid #409EFF;width:100%;flex-wrap: nowrap;height: 50px;box-sizing:border-box"
                    class="flex flex-between"
                  >

                    <input
                      class="tagNameIpt"
                      v-model="item.tagName"
                      maxLength="20"
                      placeholder="请输入片段标题"
                      size="small"
                    />
                    <p class="btnBox">
                      <!-- <p
                      class="btnBox"
                      v-if="hoverTagIndex === index"
                    > -->
                      <el-button
                        type="text"
                        size="mini"
                        icon="el-icon-top"
                        @click.stop="moveUp(contentData.clips,index)"
                      >上移</el-button>
                      <el-button
                        type="text"
                        size="mini"
                        icon="el-icon-bottom"
                        @click.stop="moveDown(contentData.clips,index)"
                      >下移</el-button>
                      <el-button
                        @click.stop="deleteArr(contentData.clips,index)"
                        type="text"
                        size="small"
                        style="padding: 0"
                        title="删除"
                        circle
                      >
                        <i
                          style="color: #FF432E;background: #FFEEEB;border-radius: 100%;border:none;"
                          class="el-icon-circle-close"
                        ></i>
                      </el-button>
                    </p>
                  </div>
                  <div v-if="item.arr && item.arr.length !== 0">
                    <el-collapse @change="handleChange">
                      <el-collapse-item
                        v-for="(val,indexVal) in item.arr"
                        :key="indexVal"
                        :title="val.name"
                        :name="indexVal"
                        @mouseover.native="collapseOver(indexVal+item.tagName)"
                        @mouseleave.native="collapseLeave(indexVal+item.tagName)"
                      >
                        <template slot="title">
                          <div
                            class="flex"
                            style="width:100%;flex-wrap: nowrap;"
                            @click="itemDetails(val)"
                          >
                            <p
                              style="height:100%;min-width: 0;padding-right: 10px;"
                              class="itemTitle wordSingle"
                            >
                              <span
                                class="wordSingle"
                                style="padding-left:10px;flex: 1;display: block;"
                              >{{val.name}}</span>
                            </p>
                            <p
                              class="btnBox"
                              v-if="hoverIndex === indexVal+item.tagName"
                            >
                              <el-button
                                type="text"
                                size="mini"
                                icon="el-icon-top"
                                @click.stop="moveUp(item.arr,indexVal)"
                              >上移</el-button>
                              <el-button
                                type="text"
                                size="mini"
                                icon="el-icon-bottom"
                                @click.stop="moveDown(item.arr,indexVal)"
                              >下移</el-button>
                              <el-button
                                @click.stop="deleteArr(item.arr,indexVal)"
                                type="text"
                                size="small"
                                style="padding: 0"
                                title="删除"
                                circle
                              >
                                <i
                                  style="color: #FF432E;background: #FFEEEB;border-radius: 100%;font-size:13px;padding:2px;font-weight:600;"
                                  class="el-icon-close"
                                ></i>
                              </el-button>
                            </p>
                          </div>
                        </template>
                        <div
                          class="infoBox"
                          :key="val.code"
                        >
                          <p class="flex">
                            <span class="wordSingle">HiTA标识符</span>
                            <span class="wordSingle">{{val.code || '暂无'}}</span>
                          </p>
                          <p class="flex">
                            <span class="wordSingle">别名</span>
                            <el-input
                              v-model="val.elementAlias"
                              @input="inputChange($event)"
                              placeholder="请输入别名"
                              size="mini"
                            ></el-input>
                          </p>
                          <p class="flex">
                            <span class="wordSingle">定义</span>
                            <el-input
                              v-model="val.elementDefination"
                              @input="inputChange($event)"
                              placeholder="请输入定义"
                              size="mini"
                            ></el-input>
                          </p>
                          <p class="flex">
                            <span class="wordSingle">来源标识符</span>
                            <span class="wordSingle">{{val.sourceCode || '暂无'}}</span>
                          </p>
                          <!-- <p class="flex">
                            <span class="wordSingle">定义</span>
                            <span
                              class="wordSingle"
                              :title="val.ext.definition"
                              v-if="val.ext"
                            >{{val.ext.definition || '暂无'}}</span>
                            <span
                              class="wordSingle"
                              v-else
                            >暂无</span>

                          </p> -->
                          <p class="flex">
                            <span class="wordSingle">数据类型</span>
                            <span
                              class="wordSingle"
                              v-if="val.ext"
                            >{{val.ext.data_type || '暂无'}}</span>
                            <span
                              class="wordSingle"
                              v-else
                            >暂无</span>
                          </p>
                          <p class="flex">
                            <span class="wordSingle">表示格式</span>
                            <span
                              class="wordSingle"
                              v-if="val.ext"
                            >{{val.ext.display_format || '暂无'}}</span>
                            <span
                              class="wordSingle"
                              v-else
                            >暂无</span>
                          </p>
                          <!-- <p class="flex">
                          <span class="wordSingle">允许值类型</span>
                          <span class="wordSingle">不可枚举型</span>
                        </p> -->
                          <p class="flex">
                            <span class="wordSingle">允许值</span>
                            <span
                              class="wordSingle"
                              v-if="val.ext"
                            >{{val.ext.range || '暂无'}}</span>
                            <span
                              class="wordSingle"
                              v-else
                            >暂无</span>
                          </p>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                </div>
              </div>
            </div>
            <el-button
              style="position: absolute;top: 60px;right: 30px;color: #1A63EB;border-color: #1A63EB;"
              type="default"
              icon="el-icon-plus"
              @click="addClips"
              size="small"
            >添加片段名称</el-button>
          </div>
          <div
            class='titleRightListBox titleRightListBoxElse'
            style="flex:1"
            v-else
          >
            <p class="defPartTitle">
              <i class="el-icon-star-on"></i> 添加数据元
            </p>
            <div class="defPartBox flex flex-center">
              <div class="imgBox flex flex-center">
                <img src="../common/img/custom1.png" />
              </div>
              <p>从左侧数据栏中「拖动」数据元至片段中或数据元上方</p>
            </div>
            <div class="defPartBox flex flex-center">
              <div class="imgBox flex flex-center">
                <img src="../common/img/custom2.png" />
              </div>
              <p>点击“批量选择”按钮，「选择」数据元</p>
            </div>
            <div class="defPartBox flex flex-center">
              <div class="imgBox flex flex-center">
                <img src="../common/img/custom3.png" />
              </div>
              <p>在左侧数据栏中「单击」数据元</p>
            </div>
            <div class="defPartBox flex flex-center">
              <div class="imgBox flex flex-center">
                <img src="../common/img/custom4.png" />
              </div>
              <p>点击右下角“+”按钮，添加片段</p>
            </div>
            <el-button
              style="position: absolute;bottom: 30px;right: 30px;"
              type="primary"
              icon="el-icon-plus"
              title="添加片段"
              @click="addClips"
              circle
            ></el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="添加片段名称"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      size="small"
    >
      <el-form
        :model="clipsTitleForm"
        :rules="clipsTitleFormRule"
        ref="clipsTitleForm"
        label-position="right"
        label-width="80px"
      >
        <el-form-item
          label="片段名称"
          prop="clipsTitle"
        >
          <el-input
            v-model="clipsTitleForm.clipsTitle"
            placeholder="片段名称"
            maxLength="20"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="clipsTitleHandle('clipsTitleForm')"
            size="small"
          >确定</el-button>
          <el-button size="small">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { fetchApi } from '../common/apis'
import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'
import get from 'lodash/get'
import OptionsMixin from '../mixins/OptionsMixin'
import RouterMixin from '../mixins/RouterMixin'
import FormMixin from '../mixins/FormMixin'
import EventMixin from '../mixins/EventMixin'
export default {
  mixins: [OptionsMixin, RouterMixin, FormMixin, EventMixin],
  props: {
    showCategory: { type: Boolean, default: true },
    copyFormId: { type: [String, null], default: null },
  },
  data() {
    return {
      htmlLoading: false,
      contentData: {
        self: [],
        clips: [], // {tagName:'',arr:[]}
      },
      clipsTitleForm: {
        clipsTitle: '',
      },
      clipsTitleFormRule: {
        clipsTitle: [
          { required: true, message: '请输入片段名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' },
        ],
      },
      tabListArr: [
        { name: '公共资源', id: 1, icon: 'el-icon-coin' },
        { name: '自建', id: 3, icon: 'el-icon-edit' },
      ],
      activeIndex: 1,
      dialogVisible: false, // 添加标题
      treeLoading: true,
      checkAll: false,
      isIndeterminate: true,
      chooseFlag: false,
      checkList: [],
      pagination: {
        total: 0,
        page: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
      },
      activeName: 'source',
      selfData: {},
      filterText: '',
      data: [],
      treeDataSys: [], // 标准
      treeDataCus: [], // 自定义
      collectionTagSys: [], //标准数据集标签
      collectionTagCus: [], //自定义数据集标签
      tagList: [], //标签数组
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      batchList: [],
      titleInput: false,
      listArr: [],
      hoverIndex: '',
      hoverTagIndex: '',
      searchVisible: false, //搜索可见
      searchValue: '', //搜索的内容
      sliderStyle: {
        height: '55px',
        overflow: 'hidden',
        width: '100%',
        boxSizing: 'border-box',
      },
    }
  },
  computed: {
    submitBtnText: function () {
      return '保存' // this.stateId ? '保存' : '保存'
    },
    showValuesTable: function () {
      let list = get(this.getMbOptionVar('typeConfig'), 'list') || []
      let { type } = this
      let item = list.find(o => o.type === type)
      let bol = get(item, 'showValues')
      return bol
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    id(id) {
      this.stateId = id
    },
    stateId(id) {
      this.loadData()
    },
    type(type) {
      this.loadData()
    },
    activeIndex(val) {
      if (this.activeName == 'source') {
        this.data = val === 1 ? this.treeDataSys : this.treeDataCus
      } else {
        this.data = val === 1 ? this.collectionTagSys : this.collectionTagCus
      }
    },
    activeName() {
      this.searchVisible = false
      this.searchValue = ''
      this.filterText = ''
      this.batchList = []
      this.activeIndex = 1
      if (this.activeName == 'source') {
        this.getList()
      } else {
        this.getCollapseTagList()
        this.getCollectionList()
      }
    },
  },
  methods: {
    inputChange() {
      this.searchVisible = !this.searchVisible
      this.searchVisible = !this.searchVisible
    },
    // 改变tagList的高度
    changeTagHeight() {
      this.sliderStyle.height = this.sliderStyle.height == 'auto' ? '55px' : 'auto'
    },

    filterNode(value, data) {
      console.log(data)
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 获取详细信息
    itemDetails(item) {
      if (item.ext === null) {
        // let that = this
        let url = '/setElement/find'
        let query = {
          id: item.id,
        }
        fetchApi
          .call(this, url, query)
          .then(function (res) {
            item.ext = {}
            let params = JSON.parse(JSON.stringify(res.ext))
            params.map(items => {
              item.ext[items.extName] = items.extValue
            })
          })
          .catch(() => {
            console.log('err')
          })
          .finally(() => {
            console.log('err')
          })
      }
    },
    // 打开搜索
    searchHandle() {
      this.searchVisible = true
      this.searchValue = ''
      this.batchList = []
      this.$nextTick(() => {
        this.$refs.searchInputRef.focus()
      })
    },
    // 关闭搜索
    closeSearch() {
      this.searchVisible = false
      this.searchValue = ''
      this.batchList = []
    },
    // 进行搜索
    searchVal() {
      this.searchVisible = true
      this.getSecondTagList('')
    },
    handleNodeClick(data) {
      // 这里区分数据元/数据集，如果是数据元的话，因为只有两级，可以直接点击去请求数据元的接口
      // 如果是数据集的话，需要再钻入一层，判断有没有子集，没有子集的话再直接获取数据元
      let chooseArr = [
        {
          id: data.parentId,
          children: [data.id],
        },
      ]
    },

    // 添加节点
    append(data) {
      let chooseArr = [
        {
          id: data.parentId,
          children: [data.id],
        },
      ]
      if (this.activeName == 'source') {
        this.getSecondTagList(chooseArr)
      } else {
        this.getSecondCollection(data, chooseArr)
        this.getSecondTagList(data.id)
      }
    },

    // 如果是数据集的话，点击第二层，需要将数据带到子集中，没有的话，再请求右侧元素的接口
    getSecondCollection(data, categoryIds) {
      let that = this
      let url = '/set/pageList'
      let query = {
        type: 1,
        pageSize: 1e5,
        page: 1,
        parentId: data.id,
      }
      console.log(categoryIds)
      fetchApi
        .call(this, url, query)
        .then(function (res) {
          let treeSon = JSON.parse(JSON.stringify(res.records)) || []
          treeSon.map(item => {
            delete item.createDate
            delete item.updateDate
            delete item.page
            delete item.pageSize
          })
          // 如果子节点为空，那么需要在右侧元素的接口
          if (treeSon.length > 0) {
            setTimeout(() => {
              if (!data.children) {
                that.$set(data, 'children', [])
              }
              data.children = treeSon
            }, 10)
          } else {
            if (that.activeName !== 'source') {
              // 如果子节点没有的话，而且是数据集，那么接口需要换成/element/pageList
              that.getSecondTagList(data.id)
              console.log(data)
            }
          }
        })
        .catch(() => {
          that.pagination = { ...that.pagination, total: 0 }
          that.tableData = []
        })
        .finally(() => {
          // that.backfillSelectedRow()
          that.loading = false
        })
    },

    // 重新获取 数据集的 标签结构
    getCollectionList(categoryIds) {
      let that = this
      let url = '/category/pageList'
      let query = {
        type: 3,
        pageSize: 1e5,
        includeSys: '1',
        page: 1,
        parentId: '0',
      }
      if (categoryIds) {
        query.categoryIds = categoryIds
      }
      fetchApi
        .call(this, url, query)
        .then(function (res) {
          console.log(res)
          that.tagList = JSON.parse(JSON.stringify(res.records)) || []
          // 如果还有子标签的话，需要遍历一下
          that.tagList.map((item, index) => {
            that.getSecondTag(item.id, index)
          })
        })
        .catch(() => {
          that.pagination = { ...that.pagination, total: 0 }
          that.tableData = []
        })
        .finally(() => {
          // that.backfillSelectedRow()
          that.loading = false
        })
    },
    // 获取第二层tag (index:第几个tag)
    getSecondTag(id, index) {
      let that = this
      let url = '/category/pageList'
      let query = {
        type: 3,
        pageSize: 1e5,
        parentId: id,
      }
      fetchApi
        .call(this, url, query)
        .then(function (res) {
          res.records.map(item => {
            item.choosed = 0
          })
          that.tagList[index].children = [{ name: '全部', id: 'allIn', choosed: 1 }].concat(res.records)
        })
        .catch(() => {
          that.pagination = { ...that.pagination, total: 0 }
          that.tableData = []
        })
        .finally(() => {
          // that.backfillSelectedRow()
          that.loading = false
        })
    },
    handleClose() {
      this.dialogVisible = false
    },
    // 确定添加片段
    clipsTitleHandle(formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.contentData.clips.push({ tagName: that.clipsTitleForm.clipsTitle, arr: [] })
          this.dialogVisible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 添加片段
    addClips() {
      this.clipsTitleForm.clipsTitle = ''
      this.dialogVisible = true
    },
    // 添加数据源
    pushBatch(val) {
      let arr = [val]
      if (!this.chooseFlag) {
        // 首先判断  this.contentData.inner也就是子集是否为空，如果为空的话，需要添加到self这个数组里面去
        if (this.contentData.clips && this.contentData.clips.length === 0) {
          console.log(this.contentData.self)
          this.contentData.self = this.contentData.self.concat(arr)
          console.log(this.contentData.self)
        } else {
          // 如果不为空的话，需要push到数组最后一个数组中的Array里面去
          this.contentData.clips[this.contentData.clips.length - 1].arr = this.contentData.clips[this.contentData.clips.length - 1].arr.concat(arr)
          // 下面代码没实际用处，不加的话选中的数据不会实时添加到列表当中，需要滑动一下
          this.chooseFlag = !this.chooseFlag
          this.chooseFlag = !this.chooseFlag
          this.searchVisible = !this.searchVisible
          this.searchVisible = !this.searchVisible
          setTimeout(() => {}, 20)
        }
      }
    },
    // 全选
    handleCheckAllChange(val) {
      let arrChoose = this.batchList.map(item => {
        return item.name
      })
      this.checkList = val ? arrChoose : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.batchList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.batchList.length
    },
    // 确定按钮
    confirmBtn() {
      if (this.checkList.length) {
        // 需要将数组推送到右侧
        let arr = []
        // 把所有数据都带过去，不然只有字符串
        this.checkList.map(item => {
          this.batchList.map(val => {
            if (val.name === item) {
              arr.push(val)
            }
          })
        })
        console.log('arr', arr)
        // 首先判断  this.contentData.inner也就是子集是否为空，如果为空的话，需要添加到self这个数组里面去
        if (this.contentData.clips && this.contentData.clips.length === 0) {
          console.log(this.contentData.self)
          this.contentData.self = this.contentData.self.concat(arr)
          console.log(this.contentData.self)
        } else {
          // 如果不为空的话，需要push到数组最后一个数组中的Array里面去
          this.contentData.clips[this.contentData.clips.length - 1].arr = this.contentData.clips[this.contentData.clips.length - 1].arr.concat(arr)
        }
        this.checkList = []
        this.checkAll = false
        this.chooseFlag = false
      } else {
        this.chooseFlag = false
      }
    },
    handleChange(val) {
      console.log(val)
    },
    // 删除模板的某个选项
    deleteArr(item, index) {
      console.log(item, index)
      item.splice(index, 1)
      // 下面代码没实际用处，不加的话选中的数据不会实时添加到列表当中，需要滑动一下
      this.chooseFlag = true
      this.chooseFlag = false
    },
    // 上移模板的某个选项
    moveUp(item, index) {
      console.log(item, index)
      if (item.length > 1 && index !== 0) {
        var temp = item[index - 1]
        this.$set(item, index - 1, item[index])
        this.$set(item, index, temp)
        // 下面代码没实际用处，不加的话选中的数据不会实时添加到列表当中，需要滑动一下
        this.chooseFlag = true
        this.chooseFlag = false
      } else {
        this.$message.warning('到顶啦~~~')
      }
    },
    // 下移模板的某个选项
    moveDown(item, index) {
      if (item.length > 1 && index !== item.length - 1) {
        var temp = item[index + 1]
        this.$set(item, index + 1, item[index])
        this.$set(item, index, temp)
        // 下面代码没实际用处，不加的话选中的数据不会实时添加到列表当中，需要滑动一下
        this.chooseFlag = true
        this.chooseFlag = false
      } else {
        this.$message.warning('到底啦~~~')
      }
    },
    // 显示标题修改
    showInput() {
      this.titleInput = !this.titleInput
      setTimeout(() => {
        this.$refs.ipt.focus()
      }, 10)
    },
    // 隐藏标题修改
    hideInput() {
      if (this.selfData.name === '') {
        this.$message.error('标题不能为空')
        return
      }
      if (this.titleInput) {
        setTimeout(() => {
          this.titleInput = !this.titleInput
        }, 10)
      }
    },
    // 划入模块 显示按钮
    collapseOver(index) {
      this.hoverIndex = index
    },
    // 划出模块 隐藏按钮
    collapseLeave() {
      this.hoverIndex = ''
    },
    // 划入单元模块 显示按钮
    collapseTagOver(index) {
      this.hoverTagIndex = index
    },
    // 划出单元模块 隐藏按钮
    collapseTagLeave() {
      this.hoverTagIndex = ''
    },

    // 选择tag
    chooseTag(item, indexd, index) {
      // 如果是全部的话，需要将其他的都清空选中的状态，如果是其他的话，点击的时候需要置换自己的状态，然后清空全部的状态
      if (item.id === 'allIn') {
        this.tagList[index].children.map(val => {
          val.choosed = 0
        })
        this.tagList[index].children[0].choosed = 1
      } else {
        item.choosed = item.choosed == 1 ? 0 : 1
        this.tagList[index].children[0].choosed = 0
      }
      // 下面代码没实际用处，不加的话选中的数据不会实时添加到列表当中，需要滑动一下
      this.chooseFlag = !this.chooseFlag
      this.chooseFlag = !this.chooseFlag

      // 此时需要触发获取数据集的集合列表
      let categoryIds = []
      this.tagList.map(item => {
        if (item.children[0].choosed == 1) {
          // 如果是全选的话，直接过不略不急
        } else {
          let arr = {}
          arr.children = []
          arr.id = item.id
          item.children.map(val => {
            if (val.choosed == 1) {
              arr.children.push(val.id)
            }
          })
          categoryIds.push(arr)
        }
      })
      this.getCollapseTagList(categoryIds)
    },

    // 获取数据集下面的分类，因为ui不一样，相同的接口也需要不同的逻辑处理
    getCollapseTagList(categoryIds) {
      let that = this
      if (this.treeLoading) return false
      this.treeLoading = true
      let url = this.activeName == 'source' ? '/category/pageList' : '/set/pageList'
      let query = {
        type: this.activeName === 'source' ? '1' : '3',
        pageSize: 1e5,
        page: 1,
        parentId: '0',
      }
      if (this.activeName == 'collection') {
        query.categoryIds = categoryIds || []
      }
      fetchApi
        .call(this, url, query)
        .then(function (res) {
          that.collectionTagSys = []
          that.collectionTagCus = []
          that.collectionTagSys = res.records.filter(item => {
            return item.isSys === '1'
          })
          that.collectionTagCus = res.records.filter(item => {
            return item.isSys === '0'
          })
          setTimeout(() => {
            that.data = that.collectionTagSys
            that.treeLoading = false
          }, 1000)
        })
        .catch(() => {
          that.pagination = { ...that.pagination, total: 0 }
          that.tableData = []
        })
        .finally(() => {
          // that.backfillSelectedRow()
          that.loading = false
        })
    },
    // 数据源列表
    getList() {
      let that = this
      if (this.loading) return false
      this.loading = true
      let url = '/category/pageList'
      let query = {
        type: this.activeName === 'source' ? '1' : '3',
        pageSize: 1e5,
        page: 1,
        parentId: '0',
      }
      this.treeLoading = true
      fetchApi
        .call(this, url, query)
        .then(function (res) {
          // that.treeLoading = false
          that.treeDataSys = []
          that.treeDataCus = []
          that.treeDataSys = res.records.filter(item => {
            return item.isSys === '1'
          })
          that.treeDataCus = res.records.filter(item => {
            return item.isSys === '0'
          })
          if (that.activeName === 'source') {
            that.treeDataSys.map(item => {
              that.geTagList(item, item.id)
            })
            that.treeDataCus.map(item => {
              that.geTagList(item, item.id)
            })
          }
          setTimeout(() => {
            that.data = that.treeDataSys
            that.treeLoading = false
          }, 1000)
        })
        .catch(() => {
          that.pagination = { ...that.pagination, total: 0 }
          that.tableData = []
        })
        .finally(() => {
          // that.backfillSelectedRow()
          that.loading = false
        })
    },
    // 获取所有分类下的tag
    geTagList(item, parentId) {
      let that = this
      let url = '/category/pageList'
      let query = {
        type: this.activeName === 'source' ? '1' : '3',
        pageSize: 1e5,
        page: 1,
        parentId: parentId,
      }
      if (this.activeName !== 'source') {
        query.includeSys = 1
      }
      fetchApi
        .call(this, url, query)
        .then(function (res) {
          let params = JSON.parse(JSON.stringify(res.records))
          item.children = params
        })
        .catch(() => {
          console.log('error')
        })
        .finally(() => {
          // that.backfillSelectedRow()
          that.loading = false
        })
    },
    // 选中
    getCheckedNodes(checkedNodes, checkedKeys, halfCheckedNodes, halfCheckedKeys) {
      let chooseArr = []
      let chooseParentsIds = []
      // 将parentId一样的放在一个数组里面
      checkedKeys.checkedNodes.map(item => {
        if (chooseParentsIds.indexOf(item.parentId) === -1) {
          chooseParentsIds.push(item.parentId)
          chooseArr.push({ id: item.parentId, children: [] })
        }
      })
      checkedKeys.checkedNodes.map(item => {
        chooseArr.map(val => {
          if (item.parentId === val.id) {
            val.children.push(item.id)
          }
        })
      })
      this.getSecondTagList(chooseArr)
    },
    getSecondTagList(categoryIds) {
      console.log(this.activeName)
      let that = this
      let url = this.activeName === 'source' ? '/element/pageList' : '/element/source'
      let query = {
        type: 1,
        pageSize: 1e5,
        page: 1,
        name: this.searchValue || '',
      }
      if (categoryIds && this.activeName === 'source') {
        query.categoryIds = categoryIds
      }
      if (this.activeName === 'collection') {
        query.ids = [categoryIds]
        delete query.type
      }
      console.log(query, this.activeName)
      fetchApi
        .call(this, url, query)
        .then(function (res) {
          that.batchList = JSON.parse(JSON.stringify(res.records))
          that.batchList.map(item => {
            delete item.createDate
            delete item.updateDate
            delete item.page
            delete item.pageSize
            item.name = item.name || item.elementAlias
            // 如果是数据集里面的元素的话不需要进行处理，如果是数据元自己的话需要进行处理一下
            if (that.activeName === 'source') {
              item.elementId = item.id
              item.id = null
            }
          })
        })
        .catch(() => {
          that.pagination = { ...that.pagination, total: 0 }
          that.tableData = []
        })
        .finally(() => {
          // that.backfillSelectedRow()
          that.loading = false
        })
    },
    updateFormConfig() {
      let { defaultFormConfig } = this
      let formConfig = {
        ...defaultFormConfig,
        formDesc: {
          name: { type: 'input', label: '名称', required: true },
          code: { type: 'input', label: '编码', required: true, attrs: { readonly: true }, vif: data => !!data.id },
          internalCode: { type: 'input', required: true, label: '内部标识符', vif: () => 1 === 2 }, // 暂时不要内部标识符
          sourceCode: { type: 'text', label: '来源标识符', attrs: { readonly: true }, vif: data => !!data.id, displayFormatter: v => (!v ? '——————' : v) },
          sourceFileName: { type: 'input', label: '来源文件名' },
          sourceFileCode: { type: 'input', label: '来源文件编码' },
          keyword: { type: 'input', label: '关键词' },
        },
        order: ['name', 'code', 'internalCode', 'sourceCode', 'sourceFileCode', 'sourceFileName', 'keyword'],
      }
      let filterFormConfig =
        get(this, '$OecpMetaDataConfig.filterFormConfig') ||
        function (params) {
          return params
        }
      formConfig = filterFormConfig(formConfig, this.type)
      this.formConfig = formConfig
    },
    clearData() {
      this.formData = {}
      this.extData = {}
      this.extList = []
      this.categoryIds = []
      let mainform = get(this, '$refs.form')
      let extForm = get(this, '$refs.ext')
      mainform && mainform.resetForm() // 规避dom未初始化调用时报错
      extForm && extForm.resetForm() // 规避dom未初始化调用时报错
    },
    loadData() {
      let that = this
      console.log(this.stateId)
      fetchApi
        .call(this, '/set/find', { id: this.stateId })
        .then(res => {
          const params = JSON.parse(JSON.stringify(res))
          delete params.createDate
          delete params.updateDate
          delete params.page
          delete params.pageSize
          that.selfData = params
        })
        .finally(() => {
          that.loading = false
        })
    },
    loadInfo() {
      let that = this
      let url = '/template/findFullSubDataSet'
      let params = {
        id: this.stateId,
      }
      fetchApi
        .call(this, url, params)
        .then(function (res) {
          that.contentData = res
          console.log(that.contentData)
          if (that.contentData.selfElmts && that.contentData.selfElmts.length !== 0) {
            // 这里是判断自己节点下面是不是为空，也就是moduleCode为null的元素
            let arr = JSON.parse(JSON.stringify(that.contentData.selfElmts))
            that.contentData.self =
              arr.filter(item => {
                return item.moduleCode == null
              }) || []
            // 这是剩余的节点
            let elseArr =
              arr.filter(item => {
                return item.moduleCode !== null
              }) || []
            let clips = []
            let clipsObj = []
            elseArr.map(item => {
              if (clips.indexOf(item.moduleCode) == -1) {
                clipsObj.push({
                  tagName: item.moduleName,
                  moduleName: item.moduleName,
                  moduleCode: item.moduleCode,
                  arr: [],
                })
                clips.push(item.moduleCode)
              }
            })
            elseArr.map(item => {
              clipsObj.map(val => {
                if (val.moduleName === item.moduleName) {
                  val.arr.push(item)
                }
              })
            })
            that.contentData.clips = JSON.parse(JSON.stringify(clipsObj))
          } else {
            that.contentData.self = []
            that.contentData.clips = []
          }
          console.log(that.contentData)
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          // that.backfillSelectedRow()
          that.loading = false
        })
    },
    // 扩展数据更新，将表单数据格式化成列表数据格式  { "definition": "标识" } -> {"extName": "definition", "extValue": "标识"}
    // 注意：只处理模版配置中显示的字段。未在模版内配置的不参与处理
    extFormData2Array() {
      let { extData = {}, extList = [], extFormConfig, stateId: parentId } = this
      let newExtList = []
      // key: extName value: extRowData
      let extDataKv = extList.reduce((rs, o) => {
        return { ...rs, ...(o.extName && { [o.extName]: o }) }
      }, {})
      let keys = Object.keys(extFormConfig.formDesc || {}) // 只处理模版内配置的扩展字段
      keys.forEach(key => {
        let { type } = extFormConfig.formDesc[key]
        if (['text', 'button'].includes(type)) return // 排除掉静态文本和按钮控件
        let extValue = extData[key] === null || extData[key] === undefined ? '' : extData[key]
        if (isObject(extValue) || isArray(extValue)) {
          // 上传控件、多选控件等格式是数组或者复杂对象
          extValue = JSON.stringify(extValue)
        }
        newExtList.push({ ...extDataKv[key], extName: key, extValue, ...(parentId && { parentId }) }) // 这里追加了 parentId
      })
      return newExtList
    },
    formatDataValue(formData) {
      let newData = {}
      for (let key in formData) {
        let val = formData[key]
        newData[key] = isObject(val) || isArray(val) ? JSON.stringify(val) : val
      }
      return newData
    },
    handleSave() {
      this.htmlLoading = true
      setTimeout(() => {
        this.htmlLoading = false
      }, 1000)
      // 将数组拼装
      let paramsArr = {
        selfElmts: [],
      }
      if (this.contentData.self && this.contentData.self.length !== 0) {
        paramsArr.selfElmts = JSON.parse(JSON.stringify(this.contentData.self))
        paramsArr.selfElmts.map(item => {
          delete item.ext
        })
      }

      if (this.contentData.clips && this.contentData.clips.length !== 0) {
        this.contentData.clips.map(item => {
          if (item.arr && item.arr.length !== 0) {
            item.arr.map(val => {
              delete val.ext
              let valItem = JSON.parse(JSON.stringify(val))
              valItem.moduleName = item.tagName
              paramsArr.selfElmts.push(valItem)
            })
          }
        })
      }
      paramsArr.selfElmts.map((item, index) => {
        item.sortInSet = index + 1
      })
      // modules 每一个模块的排序 去重
      const arr = JSON.parse(JSON.stringify(paramsArr.selfElmts))
      const id = 'moduleCode'
      // const newArr = arr.reduce((all, next) => (all.some(item => item[moduleName] == next[moduleName]) ? all : [...all, next]), [])
      // debugger
      // let unNullCode = newArr.filter(item => {
      //   return item.moduleName !== null
      // })
      let modules = []
      let modulesName = []
      arr.map((item, indexd) => {
        if (modulesName.indexOf(item.moduleName) == -1 && item.moduleName) {
          let obj = {}
          obj.moduleCode = ''
          obj.moduleName = item.moduleName
          obj.moduleSort = indexd + 1
          modules.push(obj)
          modulesName.push(item.moduleName)
        }
      })
      paramsArr.modules = modules
      paramsArr.self = JSON.parse(JSON.stringify(this.selfData))
      let that = this
      let url = '/template/saveFullSubDataSet'
      fetchApi
        .call(this, url, paramsArr)
        .then(function (res) {
          console.log(res)
          that.$message({ type: 'success', message: res.description || '操作成功!' })
          this.htmlLoading = false
        })
        .catch(err => {
          console.log(err)
          this.htmlLoading = false
        })
        .finally(() => {
          // that.backfillSelectedRow()
          that.loading = false
          this.htmlLoading = false
        })
    },
  },
  created() {
    this.loadData()
    this.loadInfo()
    this.updateFormConfig()
    this.getList()
  },
}
</script>
<style scoped>
.oecp-md-element-form {
  min-width: 1000px;
}
.oecp-component-header {
  padding-top: 8px;
  width: 100%;
  padding: 10px;
  align-items: center !important;
}
/deep/.el-page-header__left .el-icon-back {
  font-size: 26px;
  color: #2468f2;
}
.oecp-divider {
  margin-top: 0;
  margin-bottom: 10px;
  display: none;
}
.el-divider--horizontal {
  height: 0 !important;
  margin: 0 !important;
}
.title-style {
  /* padding-top: 6px; */
  font-size: 18px;
  font-weight: 600;
}
.boxInner {
  background: #fff;
  padding: 0 18px;
}
.typesBox {
  background: #fff;
  /* background: pink; */
  padding: 0 10px;
  font-size: 14px;
  color: #fff;
  border-radius: 2px;
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  align-items: center !important;
}
.typesBox li {
  cursor: pointer;
  color: #323232;
  border: 1px solid #979797 !important;
  height: 34px;
  padding: 0;
  line-height: 34px;
  margin-right: 10px;
  border-radius: 4px;
  width: 90px;
  text-align: center;
  font-size: 14px;
}
.typesBox li:hover,
.typesBox li.activeLi {
  background: #2468f2;
  border-color: #2468f2 !important;
  color: #fff !important;
}
.templateLeft {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  padding: 10px 4px 10px 18px;
  border: 1px solid #f8f8f8;
}
.templateLeftElse {
  border: 1px solid #f8f8f8;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.templateLeft li {
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  width: 100%;
  padding: 0 4px 0 10px;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  /* height: 300px; */
}
.tagBox {
  flex-direction: column;
  background: #f2f7ff;
  border-radius: 6px;
}
.tagTop {
  height: 50px;
  width: 100%;
  padding-right: 10px;
  box-sizing: border-box;
  align-items: center;
  display: flex;
}
.tagListBox {
  flex-wrap: wrap;
  flex: 1;
  overflow: auto;
  width: 100%;
  align-content: baseline;
}
.tagListBox p {
  padding: 4px 6px;
  /* margin: 0 10px 6px 0; */
  font-size: 14px;
  box-sizing: border-box;
  max-width: 100%;
  display: inline-block;
}

.tagListBox p span {
  border-radius: 4px;
  box-sizing: border-box;
  padding: 4px 6px;
  border: 1px solid #1a63eb;
  background: #fff;
  color: #606266;
  cursor: pointer;
  max-width: 100%;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.tagListBox p span:hover {
  border-color: #409eff;
  color: #409eff;
}
.editTemplateRight {
  border: 1px solid rgb(107, 106, 106, 0.2);
  background: #fff;
  margin-left: 0.5%;
  box-sizing: border-box;
  width: 98%;
  height: 99.5%;
  border-radius: 6px;
  flex: 1;
  /* box-shadow: 0 1px 6px 0 rgb(0 0 0 / 25%); */
  padding-right: 0 !important;
}
.titleRight {
  text-align: center;
  font-size: 18px;
  width: 100%;
  padding: 6px 0;
  margin: 0;
  background: #f2f7ff;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 6px 90px 6px 20px;
  box-sizing: border-box;
}
.titleRight i {
  font-size: 18px;
  padding-left: 8px;
}
.titleRightListBox {
  padding: 0 30px 0 25px;
  box-sizing: border-box;
  width: 100%;
  flex: 1;
  overflow: auto;
}
.itemTitle {
  padding-left: 10px;
  position: relative;
  text-indent: 10px;
}
.itemTitle:after {
  content: '';
  position: absolute;
  left: 6px;
  top: 45%;
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background: linear-gradient(#59adff, #486bff); /* 标准的语法 */
}
.titleRightListBoxElse {
  padding-top: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.titleRightListBoxElse .defPartTitle {
  color: #f5a623;
  font-size: 14px;
}
.titleRightListBoxElse .defPartTitle .el-icon-star-on {
  font-size: 18px;
}
.defPartBox {
  width: 100%;
  height: 120px;
  background: rgba(248, 248, 248, 0.5);
  border-radius: 4px;
  margin-top: 10px;
  font-size: 14px;
  color: #333;
  justify-content: flex-start !important;
}
.imgBox {
  width: 200px;
}
/deep/.el-tabs--card > .el-tabs__header {
  border-bottom: none !important;
}
/deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 1px solid #e4e7ed;
}
/* /deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
  height: 30px;
} */
.btnBox {
  padding-right: 10px;
  text-align: start;
  width: 230px;
}
p {
  margin: 0;
}
/deep/.el-collapse-item__header {
  height: 40px;
}
/deep/.el-collapse-item__content {
  padding-bottom: 10px !important;
}
.infoBox p {
  border-bottom: 1px dotted #dedede;
  padding: 6px 0;
  width: 100%;
  flex-wrap: nowrap;
}
.infoBox p:last-of-type {
  border-bottom: none;
}
.infoBox p span:first-of-type {
  width: 110px;
  padding: 0 10px;
  color: #909090;
  font-size: 14px;
  display: block;
}
.infoBox p span:nth-of-type(2) {
  flex: 1;
  font-size: 14px;
  display: block;
}
/deep/.el-collapse-item__wrap {
  background: #f7f7f7 !important;
  border-radius: 8px;
  padding: 2px 15px 0;
}
/deep/.el-collapse-item:hover .el-collapse-item__header {
  /* background: #efefef !important; */
}
.inputTitle {
  height: 44px;
  padding: 6px 0;
  background: #f2f7ff;
}
/deep/.el-input--suffix .el-input__inner {
  background: #f2f7ff;
  font-size: 14px;
  color: #333;
  background: none;
  border-radius: 40px;
  color: #323232;
}
/deep/.el-tree {
  background: #fff;
}
/* /deep/.is-current {
  color: #409eff;
} */
/deep/.el-icon-search,
/deep/.el-input__suffix,
/deep/.el-input__prefix {
  font-size: 20px;
  cursor: pointer;
  /* color: #2468f2 !important; */
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.el-icon-search {
  color: #409eff;
}
/deep/.el-input .el-input__icon {
  color: #fff;
  font-size: 18px;
}
.tagNameIpt {
  border: none;
  font-size: 16px;
  width: inherit;
}
.tagNameIpt:focus {
  border: none;
  outline: none !important;
}
/deep/.el-input__inner:focus {
  border: 1px solid #dcdfe6 !important;
  outline: none !important;
}
.chooseItem {
  background: #73b9ff !important;
  border-color: #7399ff !important;
  color: #fff !important;
}
.flex {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}
.flex-start {
  justify-content: flex-start;
  align-items: flex-start;
}
.flex-between {
  justify-content: space-between;
}
.flex-center {
  justify-content: center;
  align-items: center;
}
.flex-direction-column {
  flex-direction: column;
  flex-wrap: nowrap;
}
/deep/.el-icon-close {
  font-size: 18px;
}

.height100 {
  height: 100%;
  flex: 1;
  overflow: auto;
}

ul,
li {
  list-style: none;
  padding: 0px;
  margin: 0px;
}

/* 滚动条样式 start */
::-webkit-scrollbar {
  width: 4px; /* 滚动条宽度， width：对应竖滚动条的宽度  height：对应横滚动条的高度*/
  background: #fff;
}
/*定义滚动条轨道（凹槽）样式*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0); /* 较少使用 */
  border-radius: 3px;
}
/*定义滑块 样式*/
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  height: 100px; /* 滚动条滑块长度 */
  background-color: #dbdbdb;
}
/* 滚动条样式 end */

/* 超出一行省略号 start */
.wordSingle {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
/* 超出一行省略号 end */

/* 超出两行省略号 start */
.wordDouble {
  white-space: nowrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
/* 超出两行省略号 end */
/* tab start */
.el-tabs {
  width: 100%;
}
/deep/.el-tabs__nav-scroll {
  background-color: #ebeff2;
  /* padding-top: 10px; */
}

/deep/.el-tabs__nav,
/deep/.el-tabs__item {
  border: none !important;
}
/deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
  background: #e4e5e6 !important;
  border-radius: 0 !important;
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
  overflow: hidden;
}

/deep/.el-tabs__item {
  background: #e4e5e6;
  color: #1b275a;
  width: 148px;
  height: 46px;
  padding: 0 !important;
  text-align: center;
  line-height: 48px;
  border: none;
  position: relative;
}
/deep/.el-tabs__item:hover {
  color: #0c5aea;
}
/deep/.el-tabs__item:after {
  content: '';
  width: 1px;
  height: 46%;
  position: absolute;
  left: -1px;
  top: 28%;
  background: #728bce;
}
/deep/.el-tabs__item:first-of-type:after,
/deep/.el-tabs__item.is-active:after {
  display: none;
}
/deep/.el-tabs__item.is-active:before {
  content: '';
  width: 1px;
  height: 46%;
  position: absolute;
  right: 0;
  top: 28%;
  background: #fff;
  z-index: 1;
}
/deep/.el-tabs__item.is-active {
  background: #fff;
  color: #0c5aea;
  font-size: 14px;
  background-size: 100% 100%;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

/deep/.el-tabs--card > .el-tabs__header {
  border: none;
  margin: 0;
}

/* tab end */

/* checkBox start*/
.el-checkbox {
  border: 1px solid #1a63eb;
  padding: 4px 6px;
  margin: 0 10px 10px 0;
  border-radius: 4px;
  background: #fff;
}
/deep/.el-checkbox .el-checkbox__input {
  display: none !important;
}
/deep/.el-checkbox .el-checkbox__label {
  padding-left: 4px !important;
}
/deep/.el-checkbox.is-checked {
  border-color: #4790ff;
  background: #4790ff;
}
/deep/.el-checkbox.is-checked .el-checkbox__label {
  color: #fff !important;
}
/* checkBox end*/
.headerSearch {
  width: 300px;
}
.iconChoose {
  font-size: 12px;
  padding: 2px;
  border-radius: 2px;
  border: 1px solid;
}
.addBtn {
  background: #2468f2;
  border-color: #2468f2;
  padding: 0 20px;
}
.addBtn:hover {
  background: #2469f2d6;
  border-color: #2469f2d6;
}
.notAllChoose {
  height: 17px;
  width: 17px;
  display: inline-block;
  background: url('../common/img/notAllChoose.png');
  background-size: 100% 100%;
}
.allChoose {
  display: inline-block;
  height: 17px;
  width: 17px;
  background: url('../common/img/allChoose.png');
  background-size: 100% 100%;
}
.el-button--text {
  font-size: 14px;
}
/deep/.el-tree-node__content,
/deep/.el-tree-node {
  height: 30px !important;
  line-height: 30px !important;
}
/deep/.is-expanded .el-tree-node__children,
/deep/.is-expanded {
  background: #f2f7ff;
}
/deep/.is-expanded {
  position: relative !important;
}
/deep/.is-expanded:before {
  content: '';
  height: 100%;
  width: 4px;
  background: linear-gradient(180deg, #3d97ff 0%, #1260f3 100%);
  position: absolute;
  left: 0;
  top: 0;
}
/deep/.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background: #d1e3ff;
}
/deep/.custom-tree-node {
  width: 100% !important;
}
/deep/.custom-tree-node .el-button {
  width: 100% !important;
  text-align: left;
}
/deep/.el-input--suffix input {
  height: 36px !important;
  line-height: 36px !important;
}
</style>
